function isNull(el)
{
    return el === null || el === undefined;
}

function is(el, type_string)
{
    type_string = type_string.trim();

    if ( type_string === 'String' )
    {
        if ( isNull(el) ) return false;
        if ( typeof el === 'string' ) return true;
        if ( el instanceof String ) return true;

        return false;
    }

    if ( type_string === 'Number' )
    {
        if ( isNull(el) ) return false;
        if ( isNaN(el) ) return false;
        if ( Array.isArray(el) ) return false;
        if ( typeof el === "boolean" ) return false;

        return true;
    }

    if ( type_string === 'Boolean' )
    {
        if ( isNull(el) ) return false;
        if ( typeof el === "boolean" ) return true;

        return false;
    }

    if ( type_string === 'Object' )
    {
        if ( isNull(el) ) return false;
        if ( Array.isArray(el) ) return false;
        if ( typeof el === 'function' ) return false;
        if ( el === Object(el) ) return true;

        return false;
    }

    if ( type_string === 'Array' )
    {
        if ( isNull(el) ) return false;
        if ( Array.isArray(el) ) return true;

        return false;
    }

    if ( type_string === 'null' )
    {
        return isNull(el);
    }

    if ( type_string === 'function' )
    {
        return typeof el === 'function';
    }

    throw new TypeError('Unkonwn type '+type_string);
}

function isString(el) { return is(el,'String'); }
function isNumber(el) { return is(el,'Number'); }
function isBoolean(el) { return is(el,'Boolean'); }
function isObject(el) { return is(el,'Object'); }
function isArray(el) { return is(el,'Array'); }
function isFunction(el) { return is(el,'function'); }

function hasField(obj, def)
{
    if ( isNull(obj) ) return false;
    checkString(def);

    let orig_obj = obj;
    let path = def.split(":")[0].split('/');
    let type = def.split(":")[1];

    for ( let i = 0; i < path.length; i++ )
    {
        if ( path[i].length == 0 ) continue;

        obj = obj[path[i].trim()];
        if ( obj === null || obj === undefined )
            return false;
    }

    return is(obj,type);
}
 
function hasFields(el)
{
    if ( !isObject(el) ) return false;

    for ( let i = 1; i < arguments.length; i++ )
    {
        if ( !hasField(el, arguments[i]) )
            return false;
    }

    return true;
}

function checkNotNull(el)
{
    if ( isNull(el) )
        throw new TypeError('Null or undefined not allowed');
    
    return el;
}

function check(el, type_string)
{
    type_string = type_string.trim();

    if ( is(el, type_string) ) 
        return el;

    throw new TypeError('Must be a '+type_string);
}

function checkString(el) { return check(el,'String'); }
function checkNumber(el) { return check(el,'Number'); }
function checkBoolean(el) { return check(el,'Boolean'); }
function checkObject(el) { return check(el,'Object'); }
function checkArray(el) { return check(el,'Array'); }
function checkFunction(el) { return check(el,'function'); }

function checkJson(el)
{
    el = checkObject(el);

    for ( let i = 1; i < arguments.length; i++ )
    {
        checkJsonElement(el, arguments[i]);
    }

    return el;
}

function checkJsonElement(obj, def)
{
    if ( !hasField(obj,def) )
        throw new TypeError('Missing required field '+def);
    
    return obj;
}

function isSecondLevelDomainName(domain)
{
    if ( !isString(domain) ) return false;

    domain = domain.toLowerCase().trim();
    
    let parts = domain.split('.');
    
    if ( parts.length != 2 ) return false;

    return isDomainLabel(parts[0]) && isDomainLabel(parts[1]);
}

function isHostName(host)
{
    if ( !isString(host) ) return false;

    host = host.toLowerCase().trim();
    
    let parts = host.split('.');
    
    if ( parts.length < 2 ) return false;

    for ( let i = 0; i < parts.length; i++ )
    {
        if ( !isDomainLabel(parts[i]) )
            return false;
    }

    return true;
}

function isDomainLabel(label)
{
    if ( !isString(label) ) return false;
    if ( label.length > 63 || label.length == 0 ) return false;
    
    label = label.toLowerCase();

    let first_letter = /^[a-z0-9]/;
    let interior = /^[a-z0-9-]+$/;
    let last_letter = /[a-z0-9]$/;

    if ( label.search(interior) == -1 ) return false;
    if ( label.search(first_letter) == -1 ) return false;
    if ( label.search(last_letter) == -1 ) return false;

    return true;
}


module.exports =
    {
        check,
        checkNotNull,
        checkArray,
        checkString,
        checkNumber,
        checkBoolean,
        checkObject,
        checkJsonElement,
        checkJson,
        isNull,
        is,
        hasField,
        hasFields,
        isString,
        isNumber,
        isBoolean,
        isObject,
        isArray,
        isFunction,
        checkFunction,
        isDomainLabel,
        isSecondLevelDomainName,
        isHostName,
    }
